import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
  addPhoto: {
    id: 'ImageUpload.addPhoto',
    defaultMessage: '+ ADD PHOTO',
    description: 'Text for add photo button',
  },
});
